import api from '../../utils/api'

const API_BASE_URL = "/geo/GEODist";

const GEODistService = {
    async findAll(): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/find-all`);
        return response.data;
    },

    async getItemById(countryCode: string, stateCode: string, districtCode: string): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/find-one/${countryCode}/${stateCode}/${districtCode}`);
        return response.data;
    },

    async create(item: any): Promise<any> {
        const response = await api.post(`${API_BASE_URL}/create`, item);
        return response.data;
    },

    async update(countryCode: string, stateCode: string, districtCode: string, item: any): Promise<any> {
        const response = await api.put(`${API_BASE_URL}/update/${countryCode}/${stateCode}/${districtCode}`, item);
        return response.data;
    },

    async delete(countryCode: string, stateCode: string, districtCode: string): Promise<any> {
        const response = await api.delete(`${API_BASE_URL}/delete/${countryCode}/${stateCode}/${districtCode}`);
        return response.data;
    },

    async getDropdownByCountryCodeAndStateCode(countryCode: string, stateCode: string): Promise<any> {
        const response = await api.get(`${API_BASE_URL}/get-dropdown-by-country-state/${countryCode}/${stateCode}`);
        return response.data;
    },
};

export default GEODistService;